import React from 'react'
import { useIsMobile } from '@yes.technology/react-toolkit'
import { useFilterFieldsContext } from '../../context'
import { useSectionFilteraction } from '../Section/SectionContext'
import CommonControls from './CommonControls'
import type { RightHeaderElementProps } from './RightHeaderElement.types'

const RightHeaderElement = ({ onRemoveClick }: RightHeaderElementProps) => {
  const isMobile = useIsMobile()
  const { shouldHideFilters } = useSectionFilteraction()
  const { config } = useFilterFieldsContext()
  const { enableComposition } = config

  if (isMobile || shouldHideFilters || !enableComposition) {
    return <div />
  }

  return <CommonControls onRemoveClick={onRemoveClick} />
}

export default RightHeaderElement
